import moment from 'moment';

export default (birthDate) => {

    if (!birthDate) return null;

    let dob = moment(birthDate, ['M/D/YYYY', 'YYYY']);

    let age = moment().diff(dob, 'years');

    const prices = [
      {
        maxAge: 50,
        price: 762,
      },
      {
        maxAge: 55,
        price: 718,
      },
      {
        maxAge: 60,
        price: 678,
      },
      {
        maxAge: 65,
        price: 620,
      },
      {
        maxAge: 70,
        price: 551,
      },
      {
        maxAge: 75,
        price: 474,
      },
      {
        maxAge: 80,
        price: 389,
      },
      {
        maxAge: 85,
        price: 297,
      },
      {
        maxAge: 90,
        price: 210,
      },
      {
        maxAge: 95,
        price: 130,
      },
      {
        maxAge: 100,
        price: 79,
      },
      {
        maxAge: 150,
        price: 0,
      },

    ];

    const price = prices.find((price) => {
      return age <= price.maxAge;
    });

    if (price) {
      return price.price;
    } else {
      return null;
    }

}